export default "__VITE_ASSET__BcZG3cqb__"